// 模拟数据服务
import API_CONFIG from '../config/api'

export const useMockData = () => {
  return !API_CONFIG.hasBackend()
}

// 模拟燃料池数据
export const getMockFuelPoolData = () => {
  return {
    fuelStats: {
      totalParticipants: 1234,
      totalInteractions: 5678,
      totalGasConsumed: 12.5,
      topDailyPoints: 8888,
      prizePool: 500,
      topRankings: [
        { wallet_address: '0x1234...5678', daily_points: 8888, interaction_count: 10 },
        { wallet_address: '0x2345...6789', daily_points: 7777, interaction_count: 9 },
        { wallet_address: '0x3456...7890', daily_points: 6666, interaction_count: 8 },
        { wallet_address: '0x4567...8901', daily_points: 5555, interaction_count: 7 },
        { wallet_address: '0x5678...9012', daily_points: 4444, interaction_count: 6 }
      ]
    },
    topRankings: [
      { wallet_address: '0x1234...5678', daily_points: 8888, interaction_count: 10 },
      { wallet_address: '0x2345...6789', daily_points: 7777, interaction_count: 9 },
      { wallet_address: '0x3456...7890', daily_points: 6666, interaction_count: 8 },
      { wallet_address: '0x4567...8901', daily_points: 5555, interaction_count: 7 },
      { wallet_address: '0x5678...9012', daily_points: 4444, interaction_count: 6 }
    ],
    prizeWinners: [
      { wallet_address: '0xabc1...def2', amount: 100, date: new Date().toISOString().split('T')[0], rank: 1 },
      { wallet_address: '0xbcd2...efa3', amount: 50, date: new Date().toISOString().split('T')[0], rank: 2 },
      { wallet_address: '0xcde3...fab4', amount: 25, date: new Date().toISOString().split('T')[0], rank: 3 }
    ],
    userRecord: {
      wallet_address: '0xYour...Address',
      interaction_count: 5,
      gas_consumed: 0.05,
      daily_points: 1234,
      has_referrer: true
    }
  }
}

// 模拟团队数据
export const getMockTeamData = () => {
  return {
    team: {
      team_name: '星际舰队',
      invite_code: 'STORM123'
    },
    memberInfo: {
      role: 'captain'
    },
    teamMembers: [
      { member_address: '0x1234...5678', role: 'captain', joined_at: new Date().toISOString() },
      { member_address: '0x2345...6789', role: 'member', joined_at: new Date().toISOString() },
      { member_address: '0x3456...7890', role: 'member', joined_at: new Date().toISOString() }
    ],
    teamStats: {
      totalMembers: 3
    }
  }
}

export const getMockWeeklyRankings = () => {
  return [
    { teamId: 1, teamName: '银河舰队', captainAddress: '0x1234...5678', totalContribution: 50000, teamSize: 10 },
    { teamId: 2, teamName: '星际探索者', captainAddress: '0x2345...6789', totalContribution: 45000, teamSize: 8 },
    { teamId: 3, teamName: '宇宙先锋队', captainAddress: '0x3456...7890', totalContribution: 40000, teamSize: 12 }
  ]
}

// 模拟资产数据
export const getMockAssetData = () => {
  return {
    balance: 25.50,
    withdrawalThreshold: 30,
    transactions: [
      { transaction_type: 'deposit', amount: 10, source: '每日抽奖', status: 'completed', created_at: new Date().toISOString(), description: '幸运中奖' },
      { transaction_type: 'deposit', amount: 5.5, source: '星际探索', status: 'completed', created_at: new Date().toISOString(), description: '挖矿奖励' },
      { transaction_type: 'deposit', amount: 10, source: '团队奖励', status: 'completed', created_at: new Date().toISOString(), description: '团队贡献' }
    ]
  }
}

export default {
  useMockData,
  getMockFuelPoolData,
  getMockTeamData,
  getMockWeeklyRankings,
  getMockAssetData
}
